import { useState } from 'react'
import DataTable from 'react-data-table-component';
import axios from 'axios'
import logsHeader from './logsHeader'
import './Logs.scss'

const Logs = () => {
  const [search, setSearch] = useState('')
  const [data, setData] = useState([])
  const [isLoading, setLoading] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();

    if (search.length < 5)  {
      setData([]);
      return;
    }

    setLoading(true);

    axios.get(`${process.env.REACT_APP_BASE_URL}/api/user-logs?search=${search}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(response => {
        setData(response.data.data)
        setLoading(false);
      })
      .catch(err => {
        console.log(err)
        setLoading(false);
      }
    );
  };

  return (
    <div className="users-table">
      <div className="filters-container" style={{ margin: '20px 0px' }}>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            className="search-form"
            style={{ width: '400px', margin: '5px' }}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Enter lot / stock # / username / date / ip address"
          />
          <button
            disabled={isLoading || search.length < 5}
            type="submit"
            className="btn btn-primary"
            style={{ margin: '5px' }}
          >
            { isLoading ? 'Loading...' : 'Search' }
          </button>
        </form>
      </div>

      <DataTable
        className='new-table'
        columns={logsHeader}
        data={data}
        pagination
      />
    </div>
  )
}

export default Logs
